import React, { useRef } from 'react';
import EditorDashboardWrapper from '../../../layout/wrapper/EditorDashboardWrapper';
import styles from '../../../styles/pages/user/memberpartner/partner-support-ticket.module.scss'
import { Box, Button, Grid, List, ListItem, TextField, Typography } from '@mui/material';
import BackArrow from '../../../ui/Icons/BackArrow';
import message_blog_image from '../../../public/assets/images/messagedetails_inner.jpg'
import { Link } from 'react-router-dom';
import { style } from '@mui/system';
import UploadIcon from '../../../ui/Icons/Upload';
import PerfectScrollbar from "react-perfect-scrollbar"
import people from '../../../public/assets/images/people.svg'
import UploadPin from '../../../ui/Icons/UploadPin';
import DownArrowBlue from '../../../ui/Icons/DownArrowBlue';
import { useNavigate } from 'react-router';
import MemberPartnerDashboard from './MemberPartnerDashboard';
import MemberPartnerDashboardWrapper from '../../../layout/wrapper/MemberPartnerDashboardWrapper';


const fileUploadContent=[
    {
        status: true,
        name: "5028537_5563370603774986_243130120555181753_n.jpg"
    },
    {
        status: false,
        name: "5028537_5563370603774986.png"
    },
    {
        status: false,
        name: "5028537_5563370603774986_2431301205551817se_522gfjgdstAjdfdfgfvc556254dz52df52sdfd53_n.jpg"
    },
]

const viralSnareUpload = [
    {
        name: "ViralSnare Agent",
        image: `${people}`,
        date: "September 14, 2022 at 09:08 AM UTC",
        desgnation: false,
        desgnationname: "",
        paragraph: <>Hi Maxime, <br/>
        How are you doing today? <br/>
        Sure, please reset your password through the following link: viralsnare.com/pwd_reset. <br/>
        Don’t hesitate to reach back if you needed anything else! <br/>
        Kind regards,</>,
        attachedfile: false,
        attachedfilename: ""
    },
    {
        name: "Me, Myself & I",
        image: `${people}`,
        date: "September 14, 2022 at 08:56 AM UTC ",
        desgnation: true,
        desgnationname: "Partner",
        paragraph: <>Hi there, <br/> I hope all is well with you! <br/>I am trying to reset my password but it’s not letting me do it. Can you help me with this? <br/>Thank you!</>,
        attachedfile: true,
        attachedfilename: "5028537_5563370603774986.png"
    },
    {
        name: "ViralSnare Agent",
        image: `${people}`,
        date: "September 14, 2022 at 09:08 AM UTC",
        desgnation: false,
        desgnationname: "",
        paragraph: <>Hi Maxime, <br/>
        How are you doing today? <br/>
        Sure, please reset your password through the following link: viralsnare.com/pwd_reset. <br/>
        Don’t hesitate to reach back if you needed anything else! <br/>
        Kind regards,</>,
        attachedfile: false,
        attachedfilename: ""
    },
    {
        name: "John Martin",
        image: `${people}`,
        date: "September 14, 2022 at 09:08 AM UTC",
        desgnation: true,
        desgnationname: "Editor",
        paragraph: <>Hi there, <br/> I hope all is well with you! <br/>I am trying to reset my password but it’s not letting me do it. Can you help me with this? <br/>Thank you!</>,
        attachedfile: true,
        attachedfilename: "5028537_5563370603774986.png"
    },
    {
        name: "ViralSnare Agent",
        image: `${people}`,
        date: "September 14, 2022 at 09:08 AM UTC",
        desgnation: false,
        desgnationname: "",
        paragraph: <>Hi Maxime, <br/>
        How are you doing today? <br/>
        Sure, please reset your password through the following link: viralsnare.com/pwd_reset. <br/>
        Don’t hesitate to reach back if you needed anything else! <br/>
        Kind regards,</>,
        attachedfile: false,
        attachedfilename: ""
    },
    
]

const ticketDetailsSubject = [
    {
        name: "Subject:",
        paragraph: "The subject line will be shown here and can be 80 characters long at the most",
        write: false,
        writeName: ""
    },
    {
        name: "Created on:",
        paragraph: "January 14, 2023 at 8:36 PM UTC",
        write: false,
        writeName: ""
    },
    {
        name: "Last updated:",
        paragraph: "January 16, 2023 at 11:54 AM UTC",
        write: false,
        writeName: ""
    },
    {
        name: "Sender:",
        paragraph: "Me, Myself & I",
        write: true,
        writeName: "(Partner) initiated this message."
    }
]



function PartnerSupportTicket() {

    const navigate = useNavigate();

    const [sendButton,sendUpdateButton] = React.useState(false)

    const submitSendHandler = () => {
        sendUpdateButton(!sendButton);
    }
    const back_ticket_btn = () => {
        navigate('/member-partner-dashboard/support')
    }

    const fileInput = useRef(null)

    const handleClick = () => {
        fileInput.current.children[0].children[0].click()
    }

    
    return (
        <>
            <MemberPartnerDashboardWrapper>
                <Box className={styles.messagedetails}>
                    <Box className={styles.messagedetails_top}>
                        <Typography variant='h4' className={styles.cmn_h4}>Ticket Details</Typography>
                        <Button className={styles.back_btn_sec} onClick={back_ticket_btn}><i><BackArrow/></i> Back</Button>
                    </Box>

                    <Box className={styles.messagedetails_btms}>
                        <PerfectScrollbar className={styles.scrolls_container}>
                        <Box className={styles.message_details_outers}>
                            <Box className={styles.message_details_outers_lf}>

                                <Box className={styles.ticket_details_outers}>
                                    <List>
                                        {
                                            ticketDetailsSubject.map((item,index)=>(
                                                <ListItem key={index}>
                                                    <Box className={styles.subjectmatter_inner}>
                                                        <Typography variant='h5' className={styles.headinglicmn}>{item?.name}</Typography>
                                                        <Typography variant='body1'>
                                                            {item?.paragraph} 
                                                            {
                                                                item?.write ?
                                                                <Typography variant='caption' className={styles.cpy_items_span}>{item?.writeName}</Typography>
                                                                :
                                                                ""
                                                            }
                                                        </Typography>
                                                    </Box>
                                                </ListItem>
                                            ))
                                        }
                                        <ListItem>
                                            <Box className={styles.priority_listing_li}>
                                                <Typography variant='h5' className={styles.headinglicmn}>Priority:</Typography>
                                                <Typography variant='caption' className={styles.low_styl_heading}>Low</Typography>
                                            </Box>
                                        </ListItem>
                                    </List>
                                </Box>

                                <Box className={styles.file_uld_options_outr}>
                                    <Box className={styles.file_uld_options_inner}>
                                        <h5 className={styles.option_h5}>Attached Files</h5>
                                        <Box className={styles.file_uploader_all}>
                                            <PerfectScrollbar className={styles.perfectscrollinfo}>
                                                {
                                                    fileUploadContent.map((item,index)=>(
                                                        <Button className={item?.status ?`${styles.file_uploader_all_inner} ${styles.active}` : `${styles.file_uploader_all_inner}`}>
                                                            <i><UploadIcon/></i>
                                                            <Box className={styles.rt_contents}>
                                                                {item?.name}
                                                            </Box>
                                                        </Button>
                                                    ))
                                                }
                                            </PerfectScrollbar>
                                        </Box>
                                    </Box>

                         

                                    <Box className={styles.file_uld_options_inner}>
                                        <Box className={styles.status_message_field}>
                                            <Box className={styles.status_message_field_top}>
                                                 <Typography variant='caption' className={styles.status_text}>Status:</Typography>
                                                 <Typography variant='caption' className={`${styles.status_valuesec} ${styles.pendingstat}`}>Pending</Typography>
                                            </Box>

                                            <Box className={styles.status_message_field_btm}>
                                                <List>
                                                    <ListItem>
                                                        <Button className={styles.black_btns}>Respond</Button>
                                                    </ListItem>

                                                    <ListItem>
                                                        <Button className={styles.gryy_btns}>Mark as resolved</Button>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                        </Box>
                                    </Box>




                                </Box>


                            </Box>

                            <Box className={styles.message_details_outers_rt}>
                                <Box className={styles.message_fileout_div}>
                                    {
                                        sendButton ?
                                        <Box className={styles.respond_div_marks}>
                                            <Box className={styles.respond_div_marks_outer}>
                                                <List>
                                                    <ListItem>
                                                        <Button className={styles.respond_btnss}>Respond</Button>
                                                    </ListItem>
                                                    <ListItem>
                                                        <Button className={styles.respond_unread_btn}>Mark as resolved</Button>
                                                    </ListItem>
                                                </List>
                                            </Box>
                                        </Box>
                                        :
                                        <Box className={styles.file_attached_textar}>
                                            <Box className={styles.file_attached_textar_top}>
                                                <Box className={styles.dated_file_attached}>
                                                    <Box className={styles.dated_file_attached_lft}>
                                                        <Box className={styles.editor_profile_parent}>
                                                            <Box className={styles.editor_profile_parent_lft}>
                                                                <img src={people} alt=''/>
                                                            </Box>
                                                            <Box className={styles.editor_profile_parent_rtt}>
                                                                <Typography variant='h5' className={styles.cmn_h5}>Me, Myself & I</Typography>
                                                                <Typography variant='caption' className={styles.dsgntns}>(Partner)</Typography>
                                                            </Box>
                                                        
                                                        </Box>
                                                    </Box>

                                                    <Box className={styles.dated_file_attached_rtt}>
                                                        <Typography variant='caption' className={styles.date_spn_main}>September 15, 2022 at 04:37 PM UTC</Typography>
                                                    </Box>
                                                </Box>
                                            </Box>

                                            <Box className={styles.file_attached_textar_mdl}>
                                                <form>
                                                    <Grid container spacing={2} className={styles.file_attached_sec_row}>
                                                        <Grid item xs={12}>
                                                            <Box className={styles.input_box_textarea}>
                                                                <TextField
                                                                    multiline
                                                                    rows={4}
                                                                />
                                                            </Box>
                                                        </Grid>

                                                        <Grid item xs={12} className={styles.file_uploadedot_div}>
                                                            <Box className={styles.input_boxfile_attach}>
                                                                <Box className={styles.input_boxfile_outer} onClick={() => handleClick()}>
                                                                    <Typography variant='caption'><i><UploadPin/></i> Attach a file</Typography>
                                                                </Box>
                                                                <TextField type='file' className={styles.file_uploaders} ref={fileInput}/>
                                                            </Box>
                                                        </Grid>

                                                        <Grid item xs={12} className={styles.btm_option_submitted_parent}>
                                                            <Box className={styles.btm_option_submitted}>
                                                                <Button className={styles.cancel_btns_pt}>Cancel</Button> 
                                                                <Button className={styles.submitted_btn_ps} onClick={submitSendHandler}>Send <Typography variant='caption'> now</Typography></Button> 
                                                            </Box>
                                                        </Grid>
                                                    </Grid>

                                                </form>
                                            </Box>



                                        </Box>
                                    }
                                    
                                    
                                    <Box className={styles.agent_share_fileattchd}>
                                        <Box className={styles.agent_share_fileattchd_outer}>
                                            {
                                                viralSnareUpload.map((item,index)=>(
                                                    <Box className={styles.agent_share_inners} key={index}>
                                                        <Box className={styles.agent_share_inners_top}>
                                                            <Box className={styles.share_agents_lft}>
                                                                <Box className={styles.agent_info_fgr_Wrap}>
                                                                    <Box className={styles.agent_info_fgr_Wrap_img}>
                                                                        <img src={item?.image} alt=''/>
                                                                    </Box>

                                                                    <Box className={styles.agent_info_fgr_Wrap_content}>
                                                                        <Typography variant='h5' className={styles.cmn_h5}>{item?.name}</Typography>
                                                                        {
                                                                            item?.desgnation && (
                                                                                <Typography variant='caption' className={styles.desg_inner}>({item?.desgnationname})</Typography>
                                                                            )
                                                                        }
                                                                        
                                                                    </Box>
                                                                </Box>
                                                            </Box>

                                                            <Box className={styles.share_agents_rtt}>
                                                                <Typography variant='caption' className={styles.agent_date}>{item?.date} </Typography>
                                                            </Box>
                                                        </Box>

                                                        <Box className={styles.agent_share_inners_btm}>
                                                            <Box className={styles.description_box}>
                                                                <Typography variant='body1'>
                                                                    {item?.paragraph}
                                                                </Typography>
                                                            </Box>
                                                            {
                                                                item?.attachedfile && (
                                                                <Box className={styles.description_attached_boxes}>
                                                                    <Typography variant='h5' className={styles.cmn_h5}>Attached files:</Typography>
                                                                    <Button className={styles.button_pdf_styled}>
                                                                        <i><DownArrowBlue/></i>
                                                                        {item?.attachedfilename}
                                                                    </Button>
                                                                </Box>
                                                                )
                                                                
                                                            }

                                                            
                                                        </Box>
                                                    </Box>
                                                ))
                                            }

                                            


                                        </Box>



                                    </Box>
                                </Box>

                                
                            </Box>
                        </Box>
                        </PerfectScrollbar>


                    </Box>
                </Box>
            </MemberPartnerDashboardWrapper>
        </>
    );
}

export default PartnerSupportTicket;